import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  DialogActions,
  Button,
  Switch,
  Alert,
  CircularProgress,
  Typography,
} from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import { ErrorsFlattenner } from '../../common/errors-flattenner/errors-flattenner';
import TextFieldWithScan from '../../common/textfield-with-scan/textfield-with-scan';
import { IDeliveryBatch } from '../../../interfaces/delivery-company/tasks';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { DeliveryBatchQRCodePrefix } from '../../../utils/delivery-tasks';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { DeliveryBatchState } from '../../../enums/tasks';

interface ScanDeliveryDialogProps {
  onClose: () => void;
  onSubmit: (deliveryBatch: IDeliveryBatch | null) => void;
  setSnackBarResult: (t?: timestampedMessage) => void;
  tasks: IDeliveryBatch[];
}

function ScanDeliveryBatchDialog({
  onClose,
  setSnackBarResult,
  tasks,
  onSubmit,
}: ScanDeliveryDialogProps) {
  const [response, setResponse] = useState<AxiosResponse>();
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { user, config } = useContext(AuthContext);
  const [deliveryBatch, setDeliveryBatch] = useState<IDeliveryBatch | null>(
    null
  );
  // const

  const handleScan = async (encoded_value: string) => {
    let result = null;
    if (!encoded_value.startsWith(DeliveryBatchQRCodePrefix)) {
      setSnackBarResult({
        timestamp: Date.now(),
        content: 'Not a Delivery Batch',
        level: 'error',
      });
      return;
    }

    if (encoded_value == null || encoded_value === '') {
      setSnackBarResult({
        timestamp: Date.now(),
        content: 'Nothing Scanned',
        level: 'error',
      });
      return;
    }
    const batch_id_from_scan = encoded_value.slice(
      DeliveryBatchQRCodePrefix.length
    );
    try {
      const response = await axios.get<IDeliveryBatch>(
        `${API_ENDPOINT}/api/v1/delivery-batch/${batch_id_from_scan}/`,
        config
      );
      if (response.data.status == DeliveryBatchState.ASSIGNED) {
        setDeliveryBatch(response.data);
        result = response.data;
      } else {
        setSnackBarResult({
          timestamp: Date.now(),
          level: 'error',
          content: 'Batch Is Out For Delivery',
        });
        return;
      }
    } catch (e) {
      setSnackBarResult({
        timestamp: Date.now(),
        level: 'error',
        content: 'An Error Occurred',
      });
      return;
    }
    onSubmit(result);
    onClose();
  };

  return (
    <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle> Scan QRCode</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <>
            Scanning... <br /> <CircularProgress />
          </>
        ) : (
          <>
            {reason != '' && (
              <>
                <Alert
                  severity={
                    response && response.status >= 200 && response.status < 300
                      ? 'success'
                      : 'error'
                  }
                >
                  <>
                    {reason}

                    {response && response.status >= 300 && (
                      <ErrorsFlattenner rawErrors={response.data} />
                    )}
                  </>
                </Alert>
                <br />
              </>
            )}

            {
              <>
                <TextFieldWithScan
                  label="Batch QR Code"
                  type="text"
                  variant="outlined"
                  disabled={false}
                  fullWidth
                  required
                  actOnEnterPressed
                  continuousScanning
                  value={''}
                  act={(value) => {
                    handleScan(value);
                  }}
                />
              </>
            }
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}

export default ScanDeliveryBatchDialog;
